import { PerformanceMode } from '@cbsinteractive/avia-js';
import { EmbedDevice } from 'tag/ts/tag/model/type/embed/EmbedDevice';
import { AbstractSTVPlatformConfig } from 'tag/ts/tag/player/stv/configs/platforms/AbstractSTVPlatformConfig';
import { streamController } from 'tag/ts/tag/player/stv/configs/StreamController';
export class Comcast extends AbstractSTVPlatformConfig {
    constructor(params) {
        super(params);
        this.configs.properties.device = EmbedDevice.COMCAST;
        this.configs.playerOptions.performanceMode = PerformanceMode.LOW;
        this.configs.resourceConfig.playback.abr = this?.configs?.resourceConfig?.playback?.abr ?? {};
        this.configs.resourceConfig.playback.abr.maxBitrate = 3000000;
        this.configs.resourceConfig.playback.abr.startBitrate = 900000;
        this.configs.playerOptions.overrides = { deferAutoplayDetection: true };
        this.configs.resourceConfig.playback.streamController = streamController;
    }
}
